// extracted by mini-css-extract-plugin
module.exports = {"ferryLandingPagesContent":"landing-pages_ferryLandingPagesContent__yGYv2"};